import React from 'react';
import { shallow, ShallowWrapper } from 'enzyme';
import RequestHandshakeButton from './request_handshake_button';

const createProps = () => ({
  namespace: 'test-123',
  companyId: 1,
});

let props;
let wrapped: ShallowWrapper;

describe('RequestHandshakeButton', () => {
  beforeEach(() => {
    props = createProps();
    wrapped = shallow(<RequestHandshakeButton {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
